import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { websites } from '../../../../redux/websites/action';
import { pages } from '../../../../redux/pages/action';
import WebsiteComponent from '../components/website.component';
import { selectWebsiteQueryItems } from '../../../../redux/websites/selector';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { selectPageListItems } from '../../../../redux/pages/selector';



const Website= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const routeQuery = useSelector(selectWebsiteQueryItems)
  const pageList = useSelector(selectPageListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
const [pageData, setPageData] = useState(1)
  const [
    selectedWebsites,
    setSelectedWebsites
  ] = useState<any>([])
  const [
    selectedPages,
    setSelectedPages
  ] = useState<any>([])
 
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.PageName', headerName: 'PageName', sortable: true, filter: true},
      { field: 'Message.PageVersionId', headerName: 'PageVersion' },
      { field: 'Message.IsNetworkWebPageEnabled', headerName: 'Network web page enabled', cellRenderer: 'yesNoRenderer'},
      { field: 'Message.Remarks', headerName: 'Remarks'},
  
    ]);
  }

  const fetchWebsiteById= ()=>{
    dispatch(websites.query({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/query`,entity:'websites',jsonData:{
          
Records: [
  {
    
      "context": {},
      "message": {
          "Id": parmas?.id,
          "TenantId" : tenantId
      }
  
   
  }
]
}})).then(()=>{
  setIsQuery(true)
  })

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedWebsites({ ...selectedWebsites, [field]: event });
  }

  useEffect(
    () => {
      dispatch(pages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages/list`,
        entity: 'pages',
        jsonData:  {"Filters": [
                    {
                      "FieldName": "PlatformWebsiteId",
                      "FilterOperatorId": 1,
                      "FieldValue": parmas?.id,
                      "FieldType": "number"
                    }
                  ],
                  "PageNumber": pageData,
                  "PageSize": 10,
                  "SortField": "Id",
                  "SortOrder": "desc",}
    }))
      if (parmas?.id > 0) {
        fetchWebsiteById()
        createColumnDefs()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    [pageData]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedWebsites(routeQuery?.result?.items)
        setSelectedPages(pageList?.result?.items)
      }
    },
    [isQuery]
  )
 
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const updatedSelectedWebsites = { ...selectedWebsites, TenantId: tenantId };
    if (parmas?.id > 0) {
      await dispatch(websites.resetAction({ actionType: 'update' }))
      await dispatch(websites.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites`,entity:'websites',jsonData:{
           
     Records: [
       {
         
         "context": {},
         "message": updatedSelectedWebsites
     }
       
     ]
  
 }})).then(()=>{
  back()
})
 
     }else{
      await dispatch(websites.resetAction({ actionType: 'create' }))
      await dispatch(websites.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites`,entity:'websites',jsonData:{
          
      Records: [
        {
        
          "context": {},
          "message":  updatedSelectedWebsites
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })}
  }

const back=()=>{
  navigate('/web-platform/websites')
} 
 
const handleEdit=(data: any)=>{
    navigate(`platform-website-page/${data?.Message?.Id}`)
   }
   const handleAdd=()=>{
    navigate(`platform-website-page/${0}`)
  }
  
   const additionButtons: any = [
    {
      name: 'Add Pages',
      callback: () => handleAdd(),
    }
  ];
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <WebsiteComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedWebsites={selectedWebsites}
           selectedPages={selectedPages}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={parmas?.id}
           columnDefs={columnDefs}
           onEdit={handleEdit}
           additionButtons={additionButtons}
           paginationData={pageList?.result?.pagination}
           setPageData={setPageData}
          />  
    }
          </>
    )
    
    }
   
    export default Website;